import {SortableContext, useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {FC, PropsWithChildren, useMemo} from "react";
import ProposalCard from "./ProposalCard";
import FullLoader from "components/loaders/FullLoader";
import {ICandidate} from "api/types";

interface Props {
  column: {id: string};
  deleteTask: (id: string) => void;
  changeProposalNote: (id: string, name: string) => void;
  proposals: ICandidate[];
  disabled?: any;
  loading?: boolean;
  isLast?: boolean;
}

const ColumnContainer: FC<PropsWithChildren<Props>> = ({
  column,
  proposals,
  deleteTask,
  changeProposalNote,
  disabled,
  children,
  loading,
  isLast,
}) => {
  const proposalIds = useMemo(() => proposals.map((p) => p.id), [proposals]);

  const {setNodeRef, transform, transition} = useSortable({
    id: column.id,
    data: {type: "Column", column},
    disabled: !!disabled,
  });

  const style = {transition, transform: CSS.Transform.toString(transform)};

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={
        ["flex flex-col flex-1 overflow-hidden bg-brand-cream", !isLast && "border-r border-brand-border"].asClass
      }
    >
      {children}
      <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-3">
        {!loading ? (
          <SortableContext items={proposalIds}>
            {proposals.map((task) => (
              <ProposalCard
                key={task.id}
                proposal={task}
                deleteTask={deleteTask}
                changeProposalNote={changeProposalNote}
              />
            ))}
          </SortableContext>
        ) : (
          <FullLoader />
        )}
      </div>
    </div>
  );
};

export default ColumnContainer;
